// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coffee + Beige + Cream Color Scheme */
:root {
  /* Light Theme (Default) */
  --bg-primary: #F7F3EE;
  --bg-secondary: #C7A27A;
  --text-primary: #2E2A26;
  --text-secondary: #8C5A33;
  --accent-coffee: #8C5A33;
  --accent-beige: #C7A27A;
  --accent-cream: #F7F3EE;
  --border-color: #DCC5A1;
  --shadow-color: rgba(44, 42, 38, 0.1);
}

/* Dark Theme */
[data-theme="dark"] {
  --bg-primary: #1D1A16;
  --bg-secondary: #B1855A;
  --text-primary: #EDE7E1;
  --text-secondary: #DCC5A1;
  --accent-coffee: #B1855A;
  --accent-beige: #DCC5A1;
  --accent-cream: #F7F3EE;
  --border-color: #B1855A;
  --shadow-color: rgba(237, 231, 225, 0.1);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Coffee + Beige + Cream Color Scheme */\n:root {\n  /* Light Theme (Default) */\n  --bg-primary: #F7F3EE;\n  --bg-secondary: #C7A27A;\n  --text-primary: #2E2A26;\n  --text-secondary: #8C5A33;\n  --accent-coffee: #8C5A33;\n  --accent-beige: #C7A27A;\n  --accent-cream: #F7F3EE;\n  --border-color: #DCC5A1;\n  --shadow-color: rgba(44, 42, 38, 0.1);\n}\n\n/* Dark Theme */\n[data-theme=\"dark\"] {\n  --bg-primary: #1D1A16;\n  --bg-secondary: #B1855A;\n  --text-primary: #EDE7E1;\n  --text-secondary: #DCC5A1;\n  --accent-coffee: #B1855A;\n  --accent-beige: #DCC5A1;\n  --accent-cream: #F7F3EE;\n  --border-color: #B1855A;\n  --shadow-color: rgba(237, 231, 225, 0.1);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n* {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
